const MOJIBAKE_HINTS = /[ÃÂâœž]|�/

function decodeLatin1MisreadAsUtf8(input: string): string {
  try {
    const bytes = new Uint8Array(Array.from(input, (ch) => ch.charCodeAt(0) & 0xff))
    return new TextDecoder('utf-8', { fatal: false }).decode(bytes)
  } catch {
    return input
  }
}

function repairCommonPortugueseWords(input: string): string {
  const replacements: Array<[RegExp, string]> = [
    [/\bN\?s\b/g, 'Nós'],
    [/\bVoc\?s\b/g, 'Vocês'],
    [/\bP\?gina\b/g, 'Página'],
    [/\bpadr\?o\b/gi, 'padrão'],
    [/\bDiagn\?stico\b/g, 'Diagnóstico'],
    [/\bt\?cnico\b/gi, 'técnico'],
    [/\ban\?lise\b/gi, 'análise'],
    [/\bimplanta\?\?o\b/gi, 'implantação'],
    [/\bconfigura\?\?o\b/gi, 'configuração'],
    [/\bintegra\?\?o\b/gi, 'integração'],
    [/\bopera\?\?o\b/gi, 'operação'],
    [/\bgest\?o\b/gi, 'gestão'],
    [/\bservi\?o\b/gi, 'serviço'],
    [/\bavalia\?\?o\b/gi, 'avaliação'],
    [/\bcomunica\?\?o\b/gi, 'comunicação'],
    [/\bprodu\?\?o\b/gi, 'produção'],
    [/\bmanuten\?\?o\b/gi, 'manutenção'],
    [/\bpersonaliza\?\?o\b/gi, 'personalização'],
    [/\botimiza\?\?o\b/gi, 'otimização'],
    [/\bestrat\?gia\b/gi, 'estratégia'],
    [/\bcome\?ando\b/gi, 'começando'],
    [/\bTr\?fego\b/gi, 'Tráfego'],
    [/\btr\?fego\b/gi, 'tráfego'],
    [/\bReuni\?o\b/gi, 'Reunião'],
    [/\breuni\?o\b/gi, 'reunião'],
    [/\ban\?ncios\b/gi, 'anúncios'],
    [/\bCarross\?is\b/gi, 'Carrosséis'],
    [/\bcarross\?is\b/gi, 'carrosséis'],
    [/\best\?tico\b/gi, 'estático'],
    [/\bGest\?o\b/g, 'Gestão'],
    [/\bgest\?o\b/gi, 'gestão'],
    [/\bsimult\?neas\b/gi, 'simultâneas'],
    [/\bsimultneas\b/gi, 'simultâneas'],
    [/\bsimultaneas\b/gi, 'simultâneas'],
    [/\bAt (\d+ campanhas?\b)/gi, 'Até $1'],
    [/\bDi\?rio\b/g, 'Diário'],
    [/\bdi\?rio\b/gi, 'diário'],
    [/\bimplanta\?ao\b/gi, 'implantação'],
    [/\bconfigura\?ao\b/gi, 'configuração'],
    [/\bpersonaliza\?ao\b/gi, 'personalização'],
  ]

  return replacements.reduce((acc, [pattern, replacement]) => acc.replace(pattern, replacement), input)
}

const PT_TITLE_PARTICLES = new Set([
  'a',
  'o',
  'e',
  'de',
  'da',
  'do',
  'das',
  'dos',
  'em',
  'na',
  'no',
  'nas',
  'nos',
  'para',
  'com',
  'por',
])

/** Título de categoria para slide/PDF (ex.: gestão de Tráfego → Gestão de Tráfego). */
export function formatCategoryDisplayTitle(value: string): string {
  const normalized = normalizeTextEncoding(value || '').trim()
  if (!normalized) return ''

  return normalized
    .split(/\s+/)
    .map((word, index) => {
      if (!word) return word
      const lower = word.toLowerCase()
      if (index > 0 && PT_TITLE_PARTICLES.has(lower)) return lower
      if (word.length <= 5 && word === word.toUpperCase() && /[A-Z]/.test(word)) return word
      return lower.charAt(0).toUpperCase() + lower.slice(1)
    })
    .join(' ')
}

/** Evita "(Sob demanda) (Sob demanda)" quando quantidade já está no nome. */
export function formatServiceLineLabel(name: string, quantity?: string | number): string {
  const label = normalizeTextEncoding(String(name || '')).trim()
  const q = normalizeTextEncoding(String(quantity ?? '')).trim()
  if (!label || !q || /^(cont[ií]nuo|incluso|inclu[ií]do)$/i.test(q)) return label
  const qLower = q.toLowerCase()
  if (label.toLowerCase().includes(`(${qLower})`)) return label
  const parenChunks = [...label.matchAll(/\(([^)]+)\)/g)].map((m) => m[1].toLowerCase().trim())
  if (parenChunks.some((chunk) => chunk === qLower || chunk.includes(qLower) || qLower.includes(chunk))) {
    return label
  }
  return `${label} (${q})`
}

export function normalizeTextEncoding(value: string): string {
  if (!value) return value
  if (!MOJIBAKE_HINTS.test(value) && !/\?/.test(value)) return repairCommonPortugueseWords(value)

  let current = value
  for (let i = 0; i < 2; i += 1) {
    const decoded = decodeLatin1MisreadAsUtf8(current)
    if (!decoded || decoded === current) break
    current = decoded
    if (!MOJIBAKE_HINTS.test(current)) break
  }

  return repairCommonPortugueseWords(current.replace(/\uFFFD/g, ''))
}

export function normalizeObjectEncoding<T>(payload: T): T {
  if (typeof payload === 'string') {
    return normalizeTextEncoding(payload) as T
  }

  if (Array.isArray(payload)) {
    return payload.map((item) => normalizeObjectEncoding(item)) as T
  }

  if (payload && typeof payload === 'object') {
    const entries = Object.entries(payload as unknown as Record<string, unknown>).map(([key, value]) => [
      key,
      normalizeObjectEncoding(value),
    ])
    return Object.fromEntries(entries) as T
  }

  return payload
}
